import { AxiosResponse } from "axios";
import Axios, { Response } from "../utils/Axios";
import { RequestOrderProudctType } from "../recoil/type";
import { getRecoil } from "recoil-nexus";
import { authState } from "../recoil/auth";

const ApiController = {
  store: {
    getCouponCode: async (data: {
      store_id: number;
      parent_store_id: number;
      user_token_id: number;
      price: number;
      coupon_code: string;
    }): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + "/store/getCouponCode";

        const response: any = await Axios.post(sUrl, data);

        return response.data;
      } catch (err: any) {
        console.error("ERROR [store/getCouponCode] : ", err);

        return {
          ok: false,
          msg: "ERROR [store/getCouponCode] : " + err.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
    getKnockMain: async (
      user_id: number,
      user_token_id: number
    ): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + "/store/getKnockMain";

        const response: any = await Axios.post(sUrl, {
          user_id,
          user_token_id,
        });

        return response.data;
      } catch (err: any) {
        console.error("ERROR [store/getKnockMain] : ", err);

        return {
          ok: false,
          msg: "ERROR [store/getKnockMain] : " + err.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
    getStoreStatus: async (user_id: number): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + "/store/getStoreStatus";

        const response: any = await Axios.post(sUrl, {
          user_id,
        });

        return response.data;
      } catch (err: any) {
        console.error("ERROR [store/getStoreStatus] : ", err);

        return {
          ok: false,
          msg: "ERROR [store/getStoreStatus] : " + err.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
    getAdverList: async (
      user_id: number,
      user_token_id: number
    ): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + "/store/getAdverList";

        const response: any = await Axios.post(sUrl, {
          user_id,
          user_token_id,
        });

        return response.data;
      } catch (err: any) {
        console.error("ERROR [store/getAdverList] : ", err);

        return {
          ok: false,
          msg: "ERROR [store/getAdverList] : " + err.toString(),
          data: undefined,
          status: 500,
        };
      }
    },

    getKnockStoreData: async (data: {
      user_token_id: number;
      store_id: number;
      parent_store_id: number;
      user_id: number;
      extend_types?: number[];
      isStoreAlwaysSellingCheckoutProduct?: boolean;
    }): Promise<AxiosResponse | undefined> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/store/getKnockStoreData`;
        const response: AxiosResponse = await Axios.post(sUrl, data);

        return response;
      } catch (err: any) {
        console.error("ERROR [store/getKnockStoreData] : ", err);
      }
    },

    getStoreOrderData: async (
      store_id: number,
      parent_store_id: number,
      user_token_id: number,
      price: number
    ): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/store/getStoreOrderData`;
        const response: AxiosResponse = await Axios.post(sUrl, {
          store_id,
          parent_store_id,
          user_token_id,
          price,
        });

        return response.data;
      } catch (err: any) {
        console.error("ERROR [store/getStoreOrderData] : ", err);

        return {
          ok: false,
          msg: "ERROR [store/getStoreOrderData] : " + err.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
    // 호텔소개, 할인권소개 카드 내용 불러오기
    getAroundCard: async (user_id: number): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + "/store/getAroundCard";

        const response: any = await Axios.post(sUrl, {
          user_id,
        });

        return response.data;
      } catch (err: any) {
        console.error("ERROR [store/getAroundCard] : ", err);

        return {
          ok: false,
          msg: "ERROR [store/getAroundCard] : " + err.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
    getCardContent: async (
      card_id: number,
      lang: number
    ): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + "/store/getCardContent";

        const response: any = await Axios.post(sUrl, {
          card_id,
          lang,
        });

        return response.data;
      } catch (err: any) {
        console.error("ERROR [store/getCardContent] : ", err);

        return {
          ok: false,
          msg: "ERROR [store/getCardContent] : " + err.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
    // 매장 할인권 발송
    sendVoucher: async (
      voucher_id: number,
      parent_store_id: number,
      user_token_id: number,
      send_type: number,
      receiver_data: string,
      lang: number
    ): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + "/store/sendVoucher";
        const data = {
          voucher_id: voucher_id,
          parent_store_id: parent_store_id,
          user_token_id: user_token_id,
          send_type: send_type,
          receiver_data: receiver_data,
          lang: lang,
        };
        const response: any = await Axios.post(sUrl, data);

        return response.data;
      } catch (err: any) {
        console.error("ERROR [store/sendVoucher] : ", err);

        return {
          ok: false,
          msg: "ERROR [store/sendVoucher] : " + err.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
    getEnv: async (params: any): Promise<any> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/store/getEnv`;
        const response: any = await Axios.post(sUrl, params);
        return response;
      } catch (err: any) {
        return {
          ok: false,
          msg: "[설정 불러오기 오류]" + err.toString(),
          data: undefined,
        };
      }
    },

    setEnv: async (params: {
      store_id: number;
      app_type: number;
      env_list: {
        env_type: string;
        name: string;
        value: string;
      }[];
    }): Promise<any> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/store/setEnv`;
        const response: any = await Axios.post(sUrl, params);
        return response;
      } catch (err: any) {
        return {
          ok: false,
          msg: "[설정 저장하기 오류]" + err.toString(),
          data: undefined,
        };
      }
    },

    getEventList: async (
      user_id: number,
      user_token_id: number
    ): Promise<Response> => {
      try {
        const oParams = {
          user_id,
          user_token_id,
        };
        let sUrl = process.env.REACT_APP_API_URL + `/store/getEventList`;
        const response: any = await Axios.post(sUrl, oParams);
        return response;
      } catch (err: any) {
        return {
          ok: false,
          msg: "[이벤트 불러오기 오류]" + err.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
    setEventCoupon: async (
      event_id: number,
      user_id: number,
      user_token_id: number,
      coupon_id?: number
    ): Promise<Response> => {
      try {
        const oParams = {
          event_id,
          user_id,
          user_token_id,
          coupon_id,
        };
        let sUrl = process.env.REACT_APP_API_URL + `/store/setEventCoupon`;
        const response: any = await Axios.post(sUrl, oParams);
        return response;
      } catch (err: any) {
        return {
          ok: false,
          msg: "[이벤트 쿠폰 받기 오류]" + err.toString(),
          data: undefined,
          status: 500,
        };
      }
    },

    getUserTokenInfo: async (): Promise<Response> => {
      try {
        const oParams = {
          user_token_id: getRecoil(authState).user_token_id,
        };
        let sUrl = process.env.REACT_APP_API_URL + `/store/getUserTokenInfo`;
        const response: any = await Axios.post(sUrl, oParams);
        return response;
      } catch (err: any) {
        return {
          ok: false,
          msg: "[기기 기본정보 불러오기 오류]" + err.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
    setUserTokenInfo: async (
      device_power: number,
      device_memo: string,
      device_wifi_power: number
    ): Promise<Response> => {
      try {
        const oParams = {
          user_token_id: getRecoil(authState).user_token_id,
          data: {
            device_power,
            device_memo,
            device_wifi_power,
          },
        };
        let sUrl = process.env.REACT_APP_API_URL + `/store/setUserTokenInfo`;
        const response: any = await Axios.post(sUrl, oParams);
        return response;
      } catch (err: any) {
        return {
          ok: false,
          msg: "[기기 기본정보 저장 오류]" + err.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
    getTimeSectorRecommend: async (oParams: any) => {
      try {
        let sUrl =
          process.env.REACT_APP_API_URL + "/store/getTimeSectorRecommend";
        const response = await Axios.post(sUrl, oParams);
        return response;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "[시간대별 추천매장 불러오기 오류]" + oErr.toString(),
          data: undefined,
        };
      }
    },
  },

  menu: {
    getOptions: async (
      productId: number,
      store_id: number
    ): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/menu/getOptions`;
        const data = {
          product_id: productId,
          store_id,
        };
        const response: any = await Axios.post(sUrl, data);

        return response.data;
      } catch (err: any) {
        console.error("ERROR [menu/getOptions] : ", err);

        return {
          ok: false,
          msg: "ERROR [menu/getOptions] : " + err.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
    getSetOptions: async (
      productId: number,
      storeId: number
    ): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/menu/getSetOptions`;
        const data = {
          store_id: storeId,
          set_product_id: productId,
        };
        const response: any = await Axios.post(sUrl, data);
        return response.data;
      } catch (err: any) {
        console.error("ERROR [menu/getSetOptions] : ", err);

        return {
          ok: false,
          msg: "ERROR [menu/getSetOptions] : " + err.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
  },

  order: {
    testKnock: async (store_id: number): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/order/test/knock`;
        const data = {
          store_id,
        };

        const response: any = await Axios.post(sUrl, data);

        return response.data;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "ERROR [/order/test/knock]" + oErr.toString(),
          data: undefined,
          status: 500,
        };
      }
    },

    getOrderByOrderId: async (order_id: string): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/order/getOrderByOrderId`;
        const data = {
          order_id,
        };

        const response: any = await Axios.post(sUrl, data);

        return response.data;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "ERROR [order/getOrderByOrderId]" + oErr.toString(),
          data: undefined,
          status: 500,
        };
      }
    },

    getOrderByUserTokenId: async (): Promise<Response> => {
      try {
        let sUrl =
          process.env.REACT_APP_API_URL + `/order/getOrderByUserTokenId`;
        const data = {
          user_token_id: getRecoil(authState).user_token_id,
        };

        const response: any = await Axios.post(sUrl, data);

        console.log("getOrderByUserTokenId", response.data);

        return response.data;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "ERROR [order/getOrderByUserTokenId]" + oErr.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
    cancelCustomer: async (
      order_id: string,
      order_seq: number
    ): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/order/cancelCustomer`;
        const data = {
          order_id,
          order_seq,
        };

        const response: any = await Axios.post(sUrl, data);

        return response.data;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "ERROR [order/cancelCustomer]" + oErr.toString(),
          data: undefined,
          status: 500,
        };
      }
    },

    products: async (data: RequestOrderProudctType): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + "/order/products";

        const response: AxiosResponse = await Axios.post(sUrl, data);
        // if(getResponseValidation(response)){
        return response.data;
        // }else{
        //   return {
        //     ok: false,
        //     msg: "ERROR [order/products] : ",
        //     data: undefined,
        //     status: 500,
        //   };
        // }
      } catch (err: any) {
        console.error("ERROR [order/products] : ", err);

        return {
          ok: false,
          msg: "ERROR [order/products] : " + err.toString(),
          data: undefined,
          status: 500,
        };
      }
    },

    setReview: async (data: any): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + "/order/setReview";
        const response: AxiosResponse = await Axios.post(sUrl, data);

        return response.data;
      } catch (err: any) {
        console.error("ERROR [order/setReview] : ", err);

        return {
          ok: false,
          msg: "ERROR [order/setReview] : " + err.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
  },

  auth: {
    signin: async (params: any): Promise<any> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/auth/signin`;
        const response: any = await Axios.post(sUrl, params);
        return response;
      } catch (err: any) {
        return {
          ok: false,
          msg: "[로그인 오류]" + err.toString(),
          data: undefined,
        };
      }
    },
  },

  payment: {
    request: async (params: any): Promise<any> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/payment/request`;
        const response: any = await Axios.post(sUrl, params);
        return response;
      } catch (err: any) {
        return {
          ok: false,
          msg: "[로그인 오류]" + err.toString(),
          data: undefined,
        };
      }
    },
  },

  // 삭제
  // getMenuByStoreLoginId: async (storeId: string): Promise<Response> => {
  //   try {
  //     let sUrl = process.env.REACT_APP_API_URL + `/store/getStoreData`;
  //     const data = {
  //       store_id: storeId,
  //     };

  //     const response: any = await Axios.post(sUrl, data);

  //     return response;
  //   } catch (err) {
  //     let oErr: any = err;
  //     return {
  //       ok: false,
  //       msg: "[메뉴 불러오기 오류]" + oErr.toString(),
  //       data: undefined,
  //       status: 500,
  //     };
  //   }
  // },

  area: {
    // 기기 객실 정보 불러오기
    getAreaByUserToken: async (storeId: number): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/store/getAreaByUserToken`;
        const data = {
          user_token_id: getRecoil(authState).user_token_id,
          store_id: storeId,
        };

        const response: any = await Axios.post(sUrl, data);

        return response;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "[기기 객실 정보 불러오기 오류]" + oErr.toString(),
          data: undefined,
          status: 500,
        };
      }
    },

    // 구역 불러오기
    getArea: async (storeId: number): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/store/getArea`;
        const data = {
          store_id: storeId,
        };

        const response: any = await Axios.post(sUrl, data);

        return response;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "[구역 불러오기 오류]" + oErr.toString(),
          data: undefined,
          status: 500,
        };
      }
    },

    // 구역 설정하기
    setArea: async (
      storeId: number,
      area_number: number | null,
      number: number | null
    ): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/store/setArea`;
        const data = {
          store_id: storeId,
          user_token_id: getRecoil(authState).user_token_id,
          area_number: area_number,
          number: number,
        };

        const response: any = await Axios.post(sUrl, data);

        return response;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "[구역 설정하기 오류]" + oErr.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
  },

  checkout: {
    // 퇴실알림 큐 & 로그
    notification: async (notice_detail_id: number): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/checkout/notification`;
        const oParams = {
          notice_detail_id,
        };
        const response: any = await Axios.post(sUrl, oParams);

        return response;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "[퇴실알림 큐 & 로그 오류]" + oErr.toString(),
          data: undefined,
          status: 500,
        };
      }
    },

    // 퇴실알림 상세 내용 전달
    getCheckoutNoticeDetail: async (
      notice_detail_id: number
    ): Promise<Response> => {
      try {
        let sUrl =
          process.env.REACT_APP_API_URL + `/checkout/getCheckoutNoticeDetail`;
        const oParams = {
          notice_detail_id,
        };
        const response: any = await Axios.post(sUrl, oParams);

        return response;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "[퇴실알림 상세 내용 전달 오류]" + oErr.toString(),
          data: undefined,
          status: 500,
        };
      }
    },

    // 클라이언트 확인 시간 기록 (버튼 누를 때)
    setConfirmedAtOnLog: async (
      notice_detail_id: number,
      log_id: number
    ): Promise<Response> => {
      try {
        let sUrl =
          process.env.REACT_APP_API_URL + `/checkout/setConfirmedAtOnLog`;
        const oParams = {
          notice_detail_id,
          log_id,
        };
        const response: any = await Axios.post(sUrl, oParams);

        return response;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "[클라이언트 확인 시간 기록 오류]" + oErr.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
  },

  concierge: {
    // 컨시어지 조회
    getConciergeList: async (oParams: any): Promise<Response> => {
      try {
        let sUrl =
          process.env.REACT_APP_API_URL + `/concierge/getConciergeList`;
        const response: any = await Axios.post(sUrl, oParams);
        return response;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "[컨시어지 조회 오류]" + oErr.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
    // 컨시어지 요청
    sendConciergeList: async (oParams: any): Promise<Response> => {
      try {
        let sUrl =
          process.env.REACT_APP_API_URL + `/concierge/sendConciergeList`;
        const response: any = await Axios.post(sUrl, oParams);
        return response;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "[컨시어지 요청 오류]" + oErr.toString(),
          data: oErr.data.msg || "",
          status: 500,
        };
      }
    },
    // 컨시어지 답변
    getConciergeRequestDetail: async (oParams: any): Promise<Response> => {
      try {
        let sUrl =
          process.env.REACT_APP_API_URL +
          `/concierge/getConciergeRequestDetail`;
        const response: any = await Axios.post(sUrl, oParams);
        return response;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "[컨시어지 답변 가져오기 오류]" + oErr.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
    writeMessage: async (oParams: any): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/concierge/writeMessage`;
        const response: any = await Axios.post(sUrl, oParams);
        return response;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "[컨시어지 답변하기 오류]" + oErr.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
    conciergeFinish: async (oParams: any): Promise<Response> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/concierge/finish`;
        const response: any = await Axios.post(sUrl, oParams);
        return response;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "[컨시어지 삭제 오류]" + oErr.toString(),
          data: undefined,
          status: 500,
        };
      }
    },
  },
  chat: {
    getChats: async (oParams: any) => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + "/directMessage/getChats";
        const response = await Axios.post(sUrl, oParams);
        return response;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "[knockknock 채팅 내용 불러오기 오류]" + oErr.toString(),
          data: undefined,
        };
      }
    },
    getChatRoomData: async (oParams: any) => {
      try {
        let sUrl =
          process.env.REACT_APP_API_URL + "/directMessage/getChatRoomData";
        const response = await Axios.post(sUrl, oParams);
        return response;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "[knockknock 채팅 정보 불러오기 오류]" + oErr.toString(),
          data: undefined,
        };
      }
    },
    createChatRoom: async (oParams: any) => {
      try {
        let sUrl =
          process.env.REACT_APP_API_URL + "/directMessage/createChatRoom";
        const response = await Axios.post(sUrl, oParams);
        return response;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "[knockknock 채팅방 생성하기 오류]" + oErr.toString(),
          data: undefined,
        };
      }
    },
    writeMessage: async (oParams: any) => {
      try {
        let sUrl =
          process.env.REACT_APP_API_URL + "/directMessage/writeMessage";
        const response: any = await Axios.post(sUrl, oParams);
        return response;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "[knockknock 채팅 전송 오류]" + oErr.toString(),
          data: undefined,
        };
      }
    },
    finishChat: async (oParams: any) => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + "/directMessage/finishChat";
        const response: any = await Axios.post(sUrl, oParams);
        return response;
      } catch (err) {
        let oErr: any = err;
        return {
          ok: false,
          msg: "[knockknock 채팅 종료 오류]" + oErr.toString(),
          data: undefined,
        };
      }
    },
  },

  notice: {
    getWeatherNoticeList: async (params: any): Promise<any> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/weatherNotices/list`;
        const response: any = await Axios.post(sUrl, params);
        return response;
      } catch (err: any) {
        return {
          ok: false,
          msg: "[주의사항 불러오기 오류]" + err.toString(),
          data: undefined,
        };
      }
    },
  },

  interphone: {
    getInterphoneUseStatus: async (params: any): Promise<any> => {
      try {
        let sUrl =
          process.env.REACT_APP_API_URL + `/interphone/getInterphoneUseStatus`;
        const response: any = await Axios.post(sUrl, params);
        return response;
      } catch (err: any) {
        return {
          ok: false,
          msg: "[인터폰 기능 사용 여부 가져오기 오류]" + err.toString(),
          data: undefined,
        };
      }
    },
    requestVoiceChat: async (params: any): Promise<any> => {
      try {
        let sUrl =
          process.env.REACT_APP_API_URL + `/interphone/requestVoiceChat`;
        const response: any = await Axios.post(sUrl, params);
        return response;
      } catch (err: any) {
        return {
          ok: false,
          msg: "[인터폰 채팅 요청 오류]" + err.toString(),
          data: undefined,
        };
      }
    },
    cancelVoiceChat: async (params: any): Promise<any> => {
      try {
        let sUrl =
          process.env.REACT_APP_API_URL + `/interphone/cancelVoiceChat`;
        const response: any = await Axios.post(sUrl, params);
        return response;
      } catch (err: any) {
        return {
          ok: false,
          msg: "[인터폰 채팅 취소 오류]" + err.toString(),
          data: undefined,
        };
      }
    },
    acceptVoiceChat: async (params: any): Promise<any> => {
      try {
        let sUrl =
          process.env.REACT_APP_API_URL + `/interphone/acceptVoiceChat`;
        const response: any = await Axios.post(sUrl, params);
        return response;
      } catch (err: any) {
        return {
          ok: false,
          msg: "[인터폰 채팅 수락 오류]" + err.toString(),
          data: undefined,
        };
      }
    },
    getCallers: async (params: any): Promise<any> => {
      try {
        let sUrl = process.env.REACT_APP_API_URL + `/interphone/getCallers`;
        const response: any = await Axios.post(sUrl, params);
        return response;
      } catch (err: any) {
        return {
          ok: false,
          msg: "[인터폰 채팅 대상 불러오기 오류]" + err.toString(),
          data: undefined,
        };
      }
    },
    callAvailableHotelArea: async (params: any): Promise<any> => {
      try {
        let sUrl =
          process.env.REACT_APP_API_URL + `/interphone/callAvailableHotelArea`;
        const response: any = await Axios.post(sUrl, params);
        return response;
      } catch (err: any) {
        return {
          ok: false,
          msg: "[호텔구역 리스트 가져오기 오류]" + err.toString(),
          data: undefined,
        };
      }
    },
    getUnavailableCalls: async (params: any): Promise<any> => {
      try {
        let sUrl =
          process.env.REACT_APP_API_URL + `/interphone/getUnavailableCalls`;
        const response: any = await Axios.post(sUrl, params);
        return response;
      } catch (err: any) {
        return {
          ok: false,
          msg: "[부재중 목록 가져오기 오류]" + err.toString(),
          data: undefined,
        };
      }
    },
    checkUnavailableCall: async (params: any): Promise<any> => {
      try {
        let sUrl =
          process.env.REACT_APP_API_URL + `/interphone/checkUnavailableCall`;
        const response: any = await Axios.post(sUrl, params);
        return response;
      } catch (err: any) {
        return {
          ok: false,
          msg: "[부재중 확인 처리 오류]" + err.toString(),
          data: undefined,
        };
      }
    },
    setReqCallDataReceived: async (params: any): Promise<any> => {
      try {
        let sUrl =
          process.env.REACT_APP_API_URL + `/interphone/setReqCallDataReceived`;
        const response: any = await Axios.post(sUrl, params);
        return response;
      } catch (err: any) {
        return {
          ok: false,
          msg: "[인터폰 수신 확인 처리 오류]" + err.toString(),
          data: null,
        };
      }
    },
  },
};

export default ApiController;
